(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    if (!window.lacCardAtc) {
    window.lacCardAtc = true;
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target.closest && e.target.closest('.lac-card-btn[data-lac-id]');
        if (!t || t.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var txt = t.textContent;
        t.disabled = true;
        fetch(R + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(t.dataset.lacId), quantity: 1 }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (s) {
            if (s.status) throw 0;
            t.textContent = 'Ajouté ✓';
            t.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: {},
                  sourceId: t.dataset.lacId,
                  data: {
                    source: 'product-form-component',
                    itemCount: 1,
                    productId: t.dataset.lacPid,
                    variantId: t.dataset.lacId,
                  },
                },
              })
            );
            setTimeout(function () {
              t.textContent = txt;
              t.disabled = false;
            }, 2000);
          })
          .catch(function () {
            t.textContent = 'Réessayer';
            t.disabled = false;
          });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.lacCardAtc) {
    window.lacCardAtc = true;
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target.closest && e.target.closest('.lac-card-btn[data-lac-id]');
        if (!t || t.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var txt = t.textContent;
        t.disabled = true;
        fetch(R + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(t.dataset.lacId), quantity: 1 }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (s) {
            if (s.status) throw 0;
            t.textContent = 'Ajouté ✓';
            t.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: {},
                  sourceId: t.dataset.lacId,
                  data: {
                    source: 'product-form-component',
                    itemCount: 1,
                    productId: t.dataset.lacPid,
                    variantId: t.dataset.lacId,
                  },
                },
              })
            );
            setTimeout(function () {
              t.textContent = txt;
              t.disabled = false;
            }, 2000);
          })
          .catch(function () {
            t.textContent = 'Réessayer';
            t.disabled = false;
          });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
